/**
 * ChatWidgetHost — single global mount for the ChatWidget (wrapPageElement in
 * gatsby-theme-objects/gatsby-browser.js). Replaces the per-Layout mount so the
 * widget also exists on pages WITHOUT Layout (/pricing/, configurator shells).
 *
 * Renders null until client mount (no SSR/hydration mismatch), and never on:
 *  - embedded contexts (iframes)
 *  - internal/admin surfaces (dashboard, pricing-engine, CMS admin)
 */

import React, { lazy, useEffect, useState, Suspense } from 'react';

const ChatWidget = lazy(() => import('./index'));

const EXCLUDED_PATHS = [/^\/dashboard/, /^\/pricing-engine/, /^\/admin/, /\/quote\/print/];

function excluded(pathname) {
  return EXCLUDED_PATHS.some((re) => re.test(pathname || ''));
}

const ChatWidgetHost = ({ location }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;
  try {
    if (window.self !== window.top) return null; // never inside an iframe
  } catch (_) {
    return null;
  }
  const pathname = (location && location.pathname) || window.location.pathname;
  if (excluded(pathname)) return null;

  return (
    <Suspense fallback={null}>
      <ChatWidget key="objects-chat-widget" />
    </Suspense>
  );
};

export default ChatWidgetHost;
